import { Component, Input, OnInit } from '@angular/core';
import { ShowPerformance } from '../../../models/showperformance.model';
import { usePrivilege } from '../../auth/privilege-hooks';
import { Privileges } from '../../../models/privileges';

@Component({
    selector: 'app-performance-day-list-item',
    templateUrl: './performance-day-list-item.component.html',
    styleUrls: ['./performance-day-list-item.component.scss'],
    standalone: false
})
export class PerformanceDayListItemComponent implements OnInit {

  @Input() public performance: ShowPerformance;

  /** Signal-reactive; re-evaluates when the user signal loads. */
  protected canEditPerformances = usePrivilege(Privileges.PerformancesEdit);

  constructor() {
  }

  public get today(): string {
    const today = new Date();
    return `${ today.toISOString().split('T')[0] }`;
  }

  ngOnInit() {
  }

  protected getEarlyShiftBackgroundColor(performance: ShowPerformance, earlyShiftForCrew: boolean): string {
    if (earlyShiftForCrew === true) {
      const aanvang = performance.datetime.split('T')[1].split(':')[0] + ':' + performance.datetime.split('T')[1].split(':')[1];
      if (aanvang === '16:00') {
        return 'early-shift-matinee';
      }
      return 'early-shift';
    }
    return '';
  }

    protected navigateToPerformanceEditPage(performance: ShowPerformance): void {
        throw new Error('Not yet implemented');
    }
}
